import { render, staticRenderFns } from "./tongjiTable.vue?vue&type=template&id=240f6fc6&scoped=true&"
import script from "./tongjiTable.vue?vue&type=script&lang=js&"
export * from "./tongjiTable.vue?vue&type=script&lang=js&"
import style0 from "./tongjiTable.vue?vue&type=style&index=0&id=240f6fc6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240f6fc6",
  null
  
)

export default component.exports